import { render, staticRenderFns } from "./NumberAccTrans.vue?vue&type=template&id=084c1e10"
import script from "./NumberAccTrans.vue?vue&type=script&lang=js"
export * from "./NumberAccTrans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports